import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "w-full flex justify-end" }


const __default__ = {
  inheritAttrs: false,
};

import AIcon from "@ai-nc/a-components/src/components/media/AIcon.vue";


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'AModal',
  props: {
    showBackground: { type: Boolean },
    hideClose: { type: Boolean },
    modelValue: { type: Boolean },
    heading: null
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: "update:modelValue", value: boolean): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  /** Should the background be grayed out */
  showBackground?: boolean;
  /** Show close */
  hideClose?: boolean;
  /** The state of the modal, open or closed */
  modelValue: boolean;
  /** The heading to be displayed if the slot is not filled */
  heading?: string;
}





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "#modals" }, [
    (__props.modelValue)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass([
        'relative w-full h-full flex justify-center items-center z-[1000]',
        !__props.showBackground ? 'bg-black bg-opacity-50 pointer-events-auto' : '',
      ])
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["a-card-active relative pointer-events-auto flex flex-col justify-between gap-8", _ctx.$attrs.class])
          }, [
            (!__props.hideClose)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "absolute top-0 right-0 h-6 w-6 p-1 border-gray-500 border-l-[0.0625rem] border-b-[0.0625rem] rounded-bl hover:bg-black hover:bg-opacity-20 cursor-pointer",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('update:modelValue', false)))
                }, [
                  _createVNode(AIcon, {
                    icon: "x",
                    class: "text-gray-500"
                  })
                ]))
              : _createCommentVNode("", true),
            _renderSlot(_ctx.$slots, "heading", {}, () => [
              _createElementVNode("h3", null, _toDisplayString(__props.heading), 1)
            ]),
            _renderSlot(_ctx.$slots, "default"),
            _createElementVNode("div", _hoisted_1, [
              _renderSlot(_ctx.$slots, "footer")
            ])
          ], 2)
        ], 2))
      : _createCommentVNode("", true)
  ]))
}
}

})